/* import __COLOCATED_TEMPLATE__ from './home-screen-suggestions-toggle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();